import { Button, Text } from "@telegram-apps/telegram-ui";
import React from "react";
import { addExpense, removeExpense } from "../../api/expense";
import { LaunchParamsContext } from "../../launchParamsContext";
import { ExpenseCategory } from "../../types";
import BottomButtons from "../BottomButtons";
import useExpenseView from "../Detail/useExpenseView";
import Popup from "../Popup";

interface NewExpenseProps {
  date?: string;
  category?: string;
  amount?: number;
  description?: string;
}

export default function NewExpense(props: NewExpenseProps) {
  const lp = React.useContext(LaunchParamsContext);

  const { component, expense } = useExpenseView(
    {
      date: props.date ? new Date(props.date) : undefined,
      category: props.category
        ? (props.category as ExpenseCategory)
        : undefined,
      amount: props.amount ?? undefined,
      description: props.description ?? undefined,
      reportedBy: lp?.tgWebAppData?.user?.username ?? undefined,
    },
    () => {
      setPopup(null);
      setDisabled(false);
    }
  );

  const [popup, setPopup] = React.useState<React.ReactNode>(null);
  const [loading, setLoading] = React.useState<boolean>(false);
  const [disabled, setDisabled] = React.useState<boolean>(false);

  const createPopup = React.useCallback(
    (expenseId: number) =>
      setPopup(
        <Popup
          children={<Text>支出を追加しました</Text>}
          revert={async () => {
            await removeExpense(expenseId);
            setDisabled(false);
            setPopup(null);
          }}
        />
      ),
    []
  );

  const submit = React.useCallback(async () => {
    setDisabled(true);
    setLoading(true);
    if (expense.amount) {
      const response = await addExpense({
        ...expense,
        amount: expense.amount,
      });
      const newExpense = (await response.json()) as { id: string };
      createPopup(parseInt(newExpense.id));
      setLoading(false);
    }
  }, [expense, createPopup, setLoading]);

  return (
    <>
      {component}
      {popup || (
        <BottomButtons>
          <Button
            size="l"
            stretched
            onClick={submit}
            loading={loading}
            disabled={disabled || expense.amount === undefined}
          >
            追加
          </Button>
        </BottomButtons>
      )}
    </>
  );
}
